/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum BrokernetProductType {
    Callidus = 'Callidus',
    GewerblicheVersicherungsprodukte = 'GewerblicheVersicherungsprodukte',
    Servo = 'Servo',
    Fremdvertrag = 'Fremdvertrag'
  }

    export const BrokernetProductTypeTranslocoMap: Record<BrokernetProductType, string> = {
    [BrokernetProductType.Callidus]: 'brokernetProductType.callidus',
    [BrokernetProductType.GewerblicheVersicherungsprodukte]: 'brokernetProductType.gewerblicheVersicherungsprodukte',
    [BrokernetProductType.Servo]: 'brokernetProductType.servo',
    [BrokernetProductType.Fremdvertrag]: 'brokernetProductType.fremdvertrag',
    };

    export const BrokernetProductTypeOptions = [
  { value: BrokernetProductType.Callidus, labelKey: 'brokernetProductType.callidus' },
  { value: BrokernetProductType.GewerblicheVersicherungsprodukte, labelKey: 'brokernetProductType.gewerblicheVersicherungsprodukte' },
  { value: BrokernetProductType.Servo, labelKey: 'brokernetProductType.servo' },
  { value: BrokernetProductType.Fremdvertrag, labelKey: 'brokernetProductType.fremdvertrag' },
    ];

